<template lang="pug">
    div(
        class="_tablew _isth",
        :class="{ _fixed: fixed, _sth: stickyhead, _stc: stickycol, _row: row, _sr: selectRow }")
        table(
            ref="table",
            class="_table",
            :class="numeric",
            :style="width ? 'min-width:' + width : null")
            colgroup(ref="colgroup", v-if="fixed")
                col(v-if="select",
                    style="width: 38px;")
                col(v-for="(c,i) in col",
                    :class="{hide: colHide[i]}",
                    :style="{width: /fr$/.test(c.width) ? parseFloat(c.width) * colMul + '%' : (c.width || 0)}")
            thead(ref="thead", class="_ns", :class="id")
                tr
                    th(v-if="select", class="nopad")
                        ib-checkbox(v-if="select&&select!='radio'", v-model="selectAll", :disabled="selectDisabled")
                    th(v-for="(th,i) in col",
                        :class="{sort: th.sort, sorted: sortCol == i }",
                        @click="sortBy(i)")
                        div
                            span(class="text") {{th.title}}
                            | &nbsp;&nbsp;
                            span(class="arrow", v-show="!colHide[i]", :class="sortDirs[i] > 0 ? 'asc' : 'dsc'")
            tbody(v-if="data.length")
                tr(v-for="(tr, index) in sorted",
                    v-show="visible[tr.id]",
                    :class="{selected: selected.indexOf(tr.id) >= 0, _disabled: tr.disabled}",
                    @click="trClick(tr, index)")
                    td(v-if="select", class="nopad")
                        component(:is="select=='radio' ? 'ib-radio' : 'ib-checkbox'",
                            v-model="selected",
                            :name="name||'table'+_uid",
                            :val="tr.id",
                            :required="required",
                            :disabled="tr.disabled",
                            :error="error",
                            :errorMissing="errorMissing",
                            :ref="'sel' + tr.id",
                            @input="input")
                    //-
                        A slot to render table-cells in each row. The parent decides how to render each data object.
                    //
                    slot(v-bind="tr.data")
            tbody(v-else)
                tr
                    td(:colspan="cols")
                        //-
                            A slot to render an empty row
                        //
                        slot(name="empty")
</template>

<script>
    /**
     * Legacy table component; DEPRECATED.
     */
    export default {
        name: 'ib-table',

        props: {
            name: String,
            col: {
                type: Array,
                default: () => []
            },
            data: {
                type: Array,
                default: () => []
            },
            value: {
                type: Array,
                default: () => []
            },
            sort: {
                type: Number,
                default: -1
            },
            sortDir: {
                type: Number,
                default: 1
            },
            stickyhead: {
                type: Boolean,
                default: true
            },
            stickycol: {
                type: Boolean,
                default: false
            },
            id: Function,
            disabled: Function,
            required: Boolean,
            row: Boolean,
            fixed: {
                type: Boolean,
                default: false
            },
            width: String,
            select: [Boolean,String],
            selectRow: Boolean,
            filter: String,
            error: String,
            errorMissing: String
        },

        data() {
            return {
                selected: this.value,
                sortCol: this.sort,
                sortDirs: this.col.map((e,i) => i == this.sort ? this.sortDir : 1),
                lastBound: {}
            }
        },

        computed: {
            selectAll: {
                get() {
                    return (this.selected.length == this.data.length);
                },
                set(value) {
                    if (value) {
                        this.selected = this.indexed.map(tr => tr.id);
                    } else {
                        this.selected = [];
                    }
                    this.$emit('input', this.selected.filter(i => this.visible[i]));
                }
            },

            selectDisabled() {
                return !this.indexed.some(e => !e.disabled && this.visible[e.id]);
            },

            indexed() {
                let data = this.data;
                let r = [];
                for (let i = 0; i < data.length; i++) {
                    r[i] = {
                        data: data[i],
                        index: i,
                        id: this.id ? this.id(data[i]) : i,
                        disabled: this.disabled ? this.disabled(data[i]) : false
                    };
                }
                return r;
            },

            sorted() {
                let r = this.indexed.slice();
                let sortCol = this.sortCol;
                if (sortCol >= 0 && sortCol < this.col.length) {
                    const sortDir = this.sortDirs[sortCol];
                    const fn = this.col[sortCol].sort;
                    const options = {
                        numeric: true,
                        sensitivity: 'base'
                    };
                    if (fn) {
                        r = r.sort((a, b) => {
                            a = fn(a.data);
                            b = fn(b.data);
                            return sortDir * (
                                typeof a === 'string' ? a.localeCompare(b, void 0, options)
                              : typeof b === 'string' ? -b.localeCompare(a, void 0, options)
                              : isNaN(a) ? -1
                              : isNaN(b) ? 1
                              : a - b);
                        });
                    }
                }
                return r;
            },

            cols() {
                return this.col.length + !!this.select;
            },

            colMul() {
                let sum = 0;
                for (let i = 0; i < this.col.length; i++) {
                    let prop = this.col[i];
                    if (prop && /fr$/.test(prop.width)) {
                        if (!prop.only || this.$media[prop.only]) {
                            sum += parseFloat(prop.width);
                        }
                    }
                }
                return 100 / (sum || 1);
            },

            colHide() {
                return this.col.map(col => col.only && !this.$media[col.only]);
            },

            visible() {
                let r = {};
                if (this.filter) {
                    const filter = RegExp(this.filter.replace(/[\\^$.|?*+()[{]/g, '\\$&'), 'i');
                    for (let i = 0; i < this.indexed.length; i++) {
                        const tr = this.indexed[i];
                        r[tr.id] = this.col.some(col => col.sort && filter.test(col.sort(tr.data)));
                    }
                } else {
                    for (let i = 0; i < this.indexed.length; i++) {
                        const tr = this.indexed[i];
                        r[tr.id] = true;
                    }
                }
                return r;
            },

            numeric() {
                return this.col.map((col,i) => col.numeric ? '_num' + (i + 1 + (this.select ? 1 : 0)) : '').join(' ').trim();
            }
        },

        watch: {
            value(value) {
                this.selected = value;
            },
            sort(value) {
                this.sortBy(value);
            },
            visible(visible) {
                const sel = this.selected.filter((i) => visible[i]);
                if (sel.length != this.selected.length) {
                    this.$emit('input', sel);
                }
            }
        },

        methods: {
            getRowData(i) {
            /**
            * To get data of row i
            * @public
            */
                return this.sorted ? this.sorted[i] : undefined;
            },

            input(value) {
                this.$emit('input', value.filter(id => this.visible[id]));
            },

            trClick(tr, index) {
                if (this.selectRow) {
                    let input = this.$refs['sel' + tr.id];
                    if (input && input.length) {
                        input[0].click();
                    }
                }
                this.$emit('trClick', tr.data, index);
            },

            sortBy(col, dir) {
                if (this.col[col].sort) {
                    if (this.sortCol == col) {
                        this.$set(this.sortDirs, col,  dir !== undefined ? dir : this.sortDirs[col] * -1);
                    } else {
                        this.sortCol = col;
                    }
                }
                this.$emit('sortByCol', col, this.sortDirs);
            },

            format(raw, col) {
                return raw == null || raw === ''
                    ? '\ufeff'
                    : (col && col.fmt || this.$string.escapeHTML)(raw);
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._tablew {
        position: relative;
        color: @fg !important;
        white-space: nowrap;
        overflow-x: auto;
        &:not(._fixed) {
            overflow-x: auto !important;
        }
        &._fixed {
            > ._table {
                table-layout: fixed;
            }
        }
        &._sth {
            th {
                position: -webkit-sticky;
                position: sticky;
                top: 0;
                z-index: 2;
            }
        }
        &._stc {
            th:first-child,
            td:first-child {
                position: -webkit-sticky;
                position: sticky;
                left: 0;
            }
            th:first-child {
                box-shadow: inset -1px -1px 0 @border-default;
                z-index: 3;
            }
            td:first-child {
                box-shadow: inset -1px 0 0 @border-default;
                z-index: 1;
                width: 150px;
            }
        }
        &._stff {
            thead,
            th:first-child,
            td:first-child {
                will-change: transform;
            }
            th {
                position: static;
            }
        }
        &._sr {
            tbody {
                tr {
                    cursor: pointer;
                    -webkit-user-select: none;
                       -moz-user-select: none;
                        -ms-user-select: none;
                            user-select: none;
                    &:hover input + span {
                        border: 1px solid @fg-accent;
                    }
                }
            }
        }
        > .progress {
            top: calc(10rem / @font-base ~' + 14px');
        }
    }
    ._table {
        width: 100%;
        border-collapse: collapse;
        transform-style: preserve-3d;
        col.hide {
            visibility: collapse;
            width: 0 !important;
            border: 0;
        }
        tr._disabled td {
            opacity: .65;
        }
        thead {
            z-index: 2;
        }
        tbody tr {
            box-shadow: inset 0 -1px 0 @border-default;
            &:hover td when (ispercentage(@table-hover)) {
                background: lighten(@bg, @table-hover);
            }
        }
        /* WebKit bug: Applying text-align: start to th doesn't work */
        th > div,
        td {
            text-align: left;
            text-align: start;
        }
        th {
            .font-size(10);
            font-weight: 600;
            line-height: 1.4;
            text-transform: uppercase;
            text-overflow: ellipsis;
            color: fade(@fg, 50%);
            padding: 5px 10px;
            background: @table-head;
            box-shadow: inset 0 -1px 0 @border-default;

            .text {
                display: inline-block;
                vertical-align: bottom;
                max-width: calc(~'100% - 1em');
                overflow: hidden;
            }
            .arrow {
                display: none;
                width: 0;
                height: 0;
            }
            .arrow.asc {
                border-left: .45em solid transparent;
                border-right: .45em solid transparent;
                border-bottom: .45em solid mix(@fg, @bg, 70%);
            }
            .arrow.dsc {
                border-left: .45em solid transparent;
                border-right: .45em solid transparent;
                border-top: .45em solid mix(@fg, @bg, 70%);
            }
            &.sort {
                cursor: pointer;
                .arrow {
                    display: inline-block;
                    opacity: .2;
                }
                &:hover when (ispercentage(@table-hover)) {
                    background: lighten(@table-head, @table-hover);
                }
            }
            &.sorted {
                .arrow {
                    opacity: .7;
                }
            }
        }
        td {
            padding: 5px 10px;
            vertical-align: top;
            text-overflow: ellipsis;
            overflow: hidden;
            background: @bg;
        }
        tr:nth-child(2n) td {
            background: darken(@bg, @table-alt);
        }

        @active: mix(@bg-accent, @bg, @table-active);
        tr.selected {
            td {
                background: @active;
            }
            &:nth-child(2n) td {
                background: darken(@active, @table-alt / 3);
            }
            &:hover td when (ispercentage(@table-hover)) {
                background: lighten(@active, @table-hover / 3);
            }
        }
        th.nopad,
        td.nopad {
            padding-left: 0 !important;
            padding-right: 0 !important;
            text-align: center;
        }

        /* Adjust vertical margin for fields */
        td > ._field {
            margin-top: -4px;
            margin-bottom: -4px;
        }
    }

    [dir=ltr] ._table {
        th:first-child,
        td:first-child {
            padding-left: 16px;
        }
        th:last-child,
        td:last-child {
            padding-right: 16px;
        }
    }
    [dir=rtl] ._table {
        th:first-child,
        td:first-child {
            padding-right: 16px;
        }
        th:last-child,
        td:last-child {
            padding-left: 16px;
        }
    }

    .gen-num(12);
    .gen-num(@n, @i: 1) when (@i <= @n) {
        ._num@{i} td:nth-child(@{i}),
        ._num@{i} th:nth-child(@{i}) > div {
            text-align: right;
            font-feature-settings: "tnum" 1;
            font-variant-numeric: tabular-nums;
        }
        .gen-num(@n, (@i + 1));
    }

    /** Style: Allow text wrap */

    ._tablew.wrap {
        white-space: normal;
    }
</style>
